export const page5 = {
  "name": "page5",
  "title": "Sleep",
  "elements": [
    {
      "type": "rating",
      "name": "sleep_hours",
      "title": "How many hours do you sleep per night during the weekdays?",
      "isRequired": true,
      "rateValues": [
        {
          "value": 1,
          "text": "Fever than 4 hours"
        },
        {
          "value": 2,
          "text": "4-6 hours"
        },
        {
          "value": 3,
          "text": "7-8 hours"
        },
        {
          "value": 4,
          "text": "More than 8 hours"
        }
      ]
    },
    {
      "type": "boolean",
      "name": "sleep_less_than_4_hours_or_more_than_10_hours",
      "title": "Do you ever sleep less than 4 hours or more than 10 hours?",
      "isRequired": true,
      "swapOrder": true
    },
    {
      "type": "rating",
      "name": "sleep_quality",
      "title": "How would you rate the quality of your sleep?",
      "isRequired": true,
      "rateType": "stars"
    },
    {
      "type": "rating",
      "name": "fatigue",
      "title": "How often do you experience noticeable fatigue? I feel tired ...",
      "autoGenerate": false,
      "isRequired": true,
      "rateValues": [
        {
          "value": 1,
          "text": "All the time"
        },
        {
          "value": 2,
          "text": "Most of the time"
        },
        {
          "value": 3,
          "text": "Sometimes"
        },
        {
          "value": 4,
          "text": "Rarely"
        },
        {
          "value": 5,
          "text": "Never"
        }
      ]
    },
    {
      "type": "rating",
      "name": "fatigue_severe",
      "title": "Was ever the fatigue so severe that it made it impossible to focus on daily routine activities?",
      "autoGenerate": false,
      "isRequired": true,
      "rateValues": [
        {
          "value": 1,
          "text": "Never"
        },
        {
          "value": 2,
          "text": "Rarely"
        },
        {
          "value": 3,
          "text": "Sometimes"
        },
        {
          "value": 4,
          "text": "Often"
        },
        {
          "value": 5,
          "text": "Always"
        }
      ]
    }
  ]
};